export default __webpack_public_path__ + "static/media/logo_sketched.05a925e0.gif";